import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './App'
import * as serviceWorker from './serviceWorker'
import * as Sentry from '@sentry/react'
import Store from './store'
import { Provider } from 'react-redux'
Sentry.init({
  dsn: 'https://5416041ffce24a5d90cdee263c069a30@sentry.bybieyang.com/5',
  release: 'lego-admin@' + process.env.npm_package_version,
  tracesSampleRate: 0.5,
})

const ErrorWapper = () => {
  return (
    <Sentry.ErrorBoundary fallback={'An error has occured'}>
      <Provider store={Store}>
        <App></App>
      </Provider>
    </Sentry.ErrorBoundary>
  )
}
const TraceWapper = Sentry.withProfiler(ErrorWapper)
ReactDOM.render(<TraceWapper />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
